export default __webpack_public_path__ + "static/media/Camerron-1Closed.3782435f.jpg";